(function () {
  'use strict';

  if (window.UnifiedCapiClient) {
    return;
  }

  const VERSION = '1.0.0';

  let requestCount = 0;
  let successCount = 0;
  let failureCount = 0;
  let duplicateCount = 0;

  let lastEventId = '';
  let lastHttpStatus = 0;
  let lastResult = null;
  let lastError = '';
  let lastSentAt = 0;


  function getConfig() {
    return (
      window.UnifiedTrackingConfig ||
      {}
    );
  }


  function getMetaConfig() {
    const config =
      getConfig();

    const providers =
      config.providers || {};

    const source =
      providers.meta;

    if (
      source &&
      typeof source === 'object' &&
      !Array.isArray(source)
    ) {
      return source;
    }

    return {
      enabled:
        source === true
    };
  }


  function getCapiConfig() {
    const meta =
      getMetaConfig();

    const source =
      meta.capi;

    if (
      source &&
      typeof source === 'object' &&
      !Array.isArray(source)
    ) {
      return source;
    }

    return {};
  }


  function isEnabled() {
    const meta =
      getMetaConfig();

    const capi =
      getCapiConfig();

    return (
      meta.enabled === true &&
      capi.enabled === true
    );
  }


  function isDebugEnabled() {
    return (
      getConfig().debug ===
      true
    );
  }


  function debugLog(
    message,
    data
  ) {
    if (!isDebugEnabled()) {
      return;
    }

    console.info(
      '[Unified CAPI Client] ' +
        message,
      data || {}
    );
  }


  function reportError(
    code,
    message,
    details
  ) {
    if (
      window.UnifiedErrors &&
      typeof window.UnifiedErrors
        .report === 'function'
    ) {
      window.UnifiedErrors
        .report(
          'warning',
          code,
          message,
          details || {}
        );

      return;
    }

    if (isDebugEnabled()) {
      console.warn(
        '[Unified CAPI Client] ' +
          message,
        details || {}
      );
    }
  }


  function normalizeString(
    value,
    maxLength
  ) {
    const result =
      String(
        value || ''
      ).trim();

    if (!maxLength) {
      return result;
    }

    return result.slice(
      0,
      maxLength
    );
  }


  function getEndpoint() {
    const capi =
      getCapiConfig();

    return normalizeString(
      capi.endpoint,
      2048
    );
  }


  function isValidEndpoint(
    value
  ) {
    try {
      const parsed =
        new URL(value);

      return (
        parsed.protocol ===
          'https:' &&
        parsed.pathname ===
          '/events'
      );
    } catch (error) {
      return false;
    }
  }


  function getCustomerPrivacyApi() {
    if (
      window.Shopify &&
      window.Shopify
        .customerPrivacy
    ) {
      return (
        window.Shopify
          .customerPrivacy
      );
    }

    return null;
  }


  function hasMarketingConsent() {
    const config =
      getConfig();

    if (
      config.consentRequired !==
      true
    ) {
      return true;
    }

    const privacyApi =
      getCustomerPrivacyApi();

    if (
      !privacyApi ||
      typeof privacyApi
        .marketingAllowed !==
        'function'
    ) {
      return false;
    }

    try {
      return (
        privacyApi
          .marketingAllowed() ===
        true
      );
    } catch (error) {
      reportError(
        'capi_marketing_consent_check_failed',
        'CAPI marketing consent check failed.',
        {
          error:
            normalizeString(
              error &&
              error.message,
              200
            )
        }
      );

      return false;
    }
  }


  function getCookie(
    name
  ) {
    if (
      typeof document ===
      'undefined' ||
      !document.cookie
    ) {
      return '';
    }

    const prefix =
      encodeURIComponent(
        name
      ) +
      '=';

    const parts =
      document.cookie.split(
        ';'
      );

    for (
      let index = 0;
      index < parts.length;
      index += 1
    ) {
      const item =
        parts[index].trim();

      if (
        item.indexOf(
          prefix
        ) === 0
      ) {
        const rawValue =
          item.slice(
            prefix.length
          );

        try {
          return decodeURIComponent(
            rawValue
          );
        } catch (error) {
          return rawValue;
        }
      }
    }

    return '';
  }


  function getEventDefinition(
    eventName
  ) {
    const config =
      getConfig();

    const events =
      config.events || {};

    const definition =
      events[eventName];

    if (
      definition &&
      typeof definition ===
        'object' &&
      !Array.isArray(
        definition
      )
    ) {
      return definition;
    }

    return {};
  }


  function getEventId(
    context
  ) {
    const source =
      context &&
      typeof context ===
        'object' &&
      !Array.isArray(context)
        ? context
        : {};

    const metadata =
      source.metadata &&
      typeof source.metadata ===
        'object' &&
      !Array.isArray(
        source.metadata
      )
        ? source.metadata
        : {};

    const value =
      metadata.event_id ||
      metadata.eventId ||
      source.event_id ||
      source.eventId ||
      '';

    return normalizeString(
      value,
      160
    );
  }


  function resolveService(
    eventName,
    payload
  ) {
    const source =
      payload &&
      typeof payload ===
        'object'
        ? payload
        : {};

    if (
      typeof source.service ===
        'string' &&
      source.service
    ) {
      return normalizeString(
        source.service,
        100
      );
    }

    const definition =
      getEventDefinition(
        eventName
      );

    return normalizeString(
      definition.service,
      100
    );
  }


  function resolveEventCategory(
    eventName,
    payload
  ) {
    const source =
      payload &&
      typeof payload ===
        'object'
        ? payload
        : {};

    if (
      typeof source
        .event_category ===
        'string' &&
      source.event_category
    ) {
      return normalizeString(
        source.event_category,
        100
      );
    }

    const definition =
      getEventDefinition(
        eventName
      );

    return normalizeString(
      definition.category,
      100
    );
  }


  function getCurrentUrl() {
    if (
      typeof window ===
        'undefined' ||
      !window.location
    ) {
      return '';
    }

    return String(
      window.location.href ||
      ''
    );
  }


  function shouldIncludeFbp() {
    return (
      getCapiConfig()
        .includeFbp ===
      true
    );
  }


  function shouldIncludeFbc() {
    return (
      getCapiConfig()
        .includeFbc ===
      true
    );
  }


  function shouldUseKeepalive() {
    return (
      getCapiConfig()
        .keepalive !==
      false
    );
  }


  function getTestEventCode() {
    return normalizeString(
      getCapiConfig()
        .testEventCode,
      100
    );
  }


  function buildPayload(
    metaEvent,
    eventName,
    payload,
    context
  ) {
    const eventId =
      getEventId(
        context
      );

    const body = {
      event_name:
        normalizeString(
          metaEvent,
          100
        ),

      event_id:
        eventId,

      event_time:
        Math.floor(
          Date.now() /
          1000
        ),

      event_source_url:
        getCurrentUrl(),

      marketing_consent:
        hasMarketingConsent(),

      ut_event_name:
        normalizeString(
          eventName,
          100
        ),

      service:
        resolveService(
          eventName,
          payload
        ),

      event_category:
        resolveEventCategory(
          eventName,
          payload
        )
    };

    const testEventCode =
      getTestEventCode();

    if (testEventCode) {
      body.test_event_code =
        testEventCode;
    }

    if (shouldIncludeFbp()) {
      const fbp =
        getCookie(
          '_fbp'
        );

      if (fbp) {
        body.fbp =
          normalizeString(
            fbp,
            255
          );
      }
    }

    if (shouldIncludeFbc()) {
      const fbc =
        getCookie(
          '_fbc'
        );

      if (fbc) {
        body.fbc =
          normalizeString(
            fbc,
            255
          );
      }
    }

    return body;
  }


  function createFailure(
    code,
    message,
    details
  ) {
    return {
      success: false,

      code:
        code,

      message:
        message,

      details:
        details || {}
    };
  }


  async function send(
    metaEvent,
    eventName,
    payload,
    context
  ) {
    if (!isEnabled()) {
      return createFailure(
        'capi_disabled',
        'CAPI client is disabled.'
      );
    }

    if (
      typeof window.fetch !==
      'function'
    ) {
      return createFailure(
        'capi_fetch_unavailable',
        'Fetch API is unavailable.'
      );
    }

    const endpoint =
      getEndpoint();

    if (
      !isValidEndpoint(
        endpoint
      )
    ) {
      return createFailure(
        'capi_endpoint_invalid',
        'CAPI endpoint is missing or invalid.',
        {
          endpoint:
            endpoint
        }
      );
    }

    if (
      !hasMarketingConsent()
    ) {
      return createFailure(
        'capi_marketing_consent_missing',
        'Marketing consent is required for CAPI.'
      );
    }

    const eventId =
      getEventId(
        context
      );

    if (!eventId) {
      reportError(
        'capi_event_id_missing',
        'CAPI event was not sent because event ID is missing.',
        {
          event:
            eventName,

          meta_event:
            metaEvent
        }
      );

      return createFailure(
        'capi_event_id_missing',
        'Event ID is required for CAPI deduplication.'
      );
    }

    const body =
      buildPayload(
        metaEvent,
        eventName,
        payload,
        context
      );

    requestCount += 1;

    lastEventId =
      eventId;

    lastSentAt =
      Date.now();

    lastError = '';

    debugLog(
      'Sending event',
      {
        event:
          eventName,

        metaEvent:
          metaEvent,

        eventId:
          eventId,

        endpoint:
          endpoint
      }
    );

    try {
      const response =
        await window.fetch(
          endpoint,
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body:
              JSON.stringify(
                body
              ),

            keepalive:
              shouldUseKeepalive()
          }
        );

      lastHttpStatus =
        response.status;

      let responseBody = null;

      try {
        responseBody =
          await response.json();
      } catch (error) {
        responseBody = {
          success: false,

          error:
            'capi_response_invalid_json'
        };
      }

      lastResult =
        responseBody;

      if (
        response.ok &&
        responseBody &&
        responseBody.success ===
          true
      ) {
        successCount += 1;

        if (
          responseBody.duplicate ===
          true
        ) {
          duplicateCount += 1;
        }

        debugLog(
          'Event accepted',
          {
            event:
              eventName,

            eventId:
              eventId,

            httpStatus:
              response.status,

            forwarded:
              responseBody
                .forwarded,

            duplicate:
              responseBody
                .duplicate
          }
        );

        return {
          success: true,

          transport:
            'meta_capi',

          http_status:
            response.status,

          event_id:
            eventId,

          forwarded:
            responseBody
              .forwarded ===
            true,

          duplicate:
            responseBody
              .duplicate ===
            true,

          response:
            responseBody
        };
      }

      failureCount += 1;

      lastError =
        normalizeString(
          responseBody &&
          (
            responseBody.error ||
            responseBody.code
          ),
          100
        ) ||
        'capi_request_failed';

      reportError(
        'capi_request_failed',
        'CAPI Worker rejected the event.',
        {
          event:
            eventName,

          event_id:
            eventId,

          http_status:
            response.status,

          error:
            lastError
        }
      );

      return {
        success: false,

        transport:
          'meta_capi',

        code:
          lastError,

        http_status:
          response.status,

        event_id:
          eventId,

        response:
          responseBody
      };
    } catch (error) {
      failureCount += 1;

      lastHttpStatus = 0;

      lastError =
        'capi_network_error';

      lastResult = null;

      reportError(
        'capi_network_error',
        'CAPI request failed at network level.',
        {
          event:
            eventName,

          event_id:
            eventId,

          error:
            normalizeString(
              error &&
              error.message,
              200
            )
        }
      );

      return {
        success: false,

        transport:
          'meta_capi',

        code:
          'capi_network_error',

        http_status:
          0,

        event_id:
          eventId
      };
    }
  }


  function isAvailable() {
    return (
      isEnabled() &&
      isValidEndpoint(
        getEndpoint()
      ) &&
      typeof window.fetch ===
        'function'
    );
  }


  function getStatus() {
    const capi =
      getCapiConfig();

    return {
      version:
        VERSION,

      enabled:
        isEnabled(),

      available:
        isAvailable(),

      endpoint:
        getEndpoint(),

      marketing_allowed:
        hasMarketingConsent(),

      test_mode:
        Boolean(
          getTestEventCode()
        ),

      keepalive:
        shouldUseKeepalive(),

      include_fbp:
        capi.includeFbp ===
        true,

      include_fbc:
        capi.includeFbc ===
        true,

      requests:
        requestCount,

      successes:
        successCount,

      failures:
        failureCount,

      duplicates:
        duplicateCount,

      last_event_id:
        lastEventId,

      last_http_status:
        lastHttpStatus,

      last_sent_at:
        lastSentAt,

      last_error:
        lastError,

      last_result:
        lastResult
    };
  }


  window.UnifiedCapiClient = {
    version:
      VERSION,

    send:
      send,

    isAvailable:
      isAvailable,

    hasMarketingConsent:
      hasMarketingConsent,

    getStatus:
      getStatus
  };


  debugLog(
    'CAPI client initialized',
    getStatus()
  );
})();